import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import { pay } from "../../../services/credit";
import { ToastContext } from "../../../hooks/context";
import { cleanObject } from "../../../helpers";
import { useCloseOtpAuthorizationPrompt } from "../../../hooks/useCloseOtpAuthorizationPrompt";
import { useGetAllChartOfAccounts } from "../../../hooks/api/queries";

const UpdateCreditWidgetLogic = ({ closeWidget, customer, onSuccess }) => {
  const [amount, setAmount] = useState(customer?.outstanding_balance);
  const [store, setStore] = useState("");
  const [note, setNote] = useState("");
  const [account, setAccount] = useState();
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [repaymentDate, setRepaymentDate] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { storeList } = useSelector((state) => state.profileDetailsReducer);
  const triggerToast = useContext(ToastContext);
  const { closeOtpAuthorizationPrompt } = useCloseOtpAuthorizationPrompt();
  const { isLoading: isLoadingBankAccountsList, data: bankAccounts } =
    useGetAllChartOfAccounts({ sub_account_type: "cash_and_bank" });

  const makeRepayment = () => {
    const data = {
      amount,
      payment_method: paymentMethod,
      store_id: store,
      ledger_account_id: account,
      note: note,
      repayment_date: repaymentDate,
    };
    setIsSubmitting(true);

    pay(customer.id, cleanObject(data))
      .then(() => {
        triggerToast("Payment successful", "success");
        onSuccess();
        closeWidget();
        closeOtpAuthorizationPrompt();
      })
      .catch((error) => {})
      .finally(() => setIsSubmitting(false));
  };

  return {
    isLoadingBankAccountsList,
    amount,
    note,
    setAmount,
    store,
    setStore,
    storeList,
    isSubmitting,
    setIsSubmitting,
    paymentMethod,
    setPaymentMethod,
    makeRepayment,
    bankAccounts: bankAccounts?.data,
    account,
    repaymentDate,
    setRepaymentDate,
    setAccount,
    setNote,
  };
};

export default UpdateCreditWidgetLogic;
